import { cn } from "@/lib/utils";

interface ThreadLineProps {
    /** 이 댓글이 부모의 마지막 자식인지 여부 */
    isLastChild?: boolean;
}

/**
 * LinkedIn 스타일 댓글 스레드 라인 컴포넌트
 * - 중첩된 댓글의 계층 구조를 시각화하는 수직/수평 선
 * - 마지막 자식의 경우 수직선이 짧게 표시됨
 * - 호버 시 색상이 변경됨 (다크 모드 지원)
 */
export const ThreadLine: React.FC<ThreadLineProps> = ({
    isLastChild = false
}) => {
    return (
        <div
            aria-hidden="true"
            role="button"
            className={cn(
                // 기본 스타일
                "relative w-[1.6rem] shrink-0 cursor-pointer",
                // 수직선 (::before 역할)
                `before:absolute before:left-1/2 before:top-0
                before:content-['']`,
                isLastChild ? "before:h-4" : "before:bottom-0",
                `before:border-l-2 before:border-grey-300
                dark:before:border-grey-600`,
                "before:transition-colors before:duration-150",
                // L자형 꺾쇠 (::after 역할)
                "after:absolute after:left-1/2 after:top-0 after:content-['']",
                "after:h-[30px] after:w-[calc(50%-2px)]",
                `after:border-b-2 after:border-l-2 after:border-grey-300
                dark:after:border-grey-600`,
                "after:-mt-1.5 after:rounded-bl-lg",
                "after:transition-colors after:duration-150",
                // 호버 상태
                "hover:before:border-grey-400 dark:hover:before:border-grey-500",
                "hover:after:border-grey-400 dark:hover:after:border-grey-500"
            )}
        />
    );
};
